export default {
  attachment_data: "The app is handling attachment data. This might take some time.",
  comments_data: "The app is handling comments data. This might take some time.",
  corrective_work_data: "The app is handling corrective work data. This might take some time.",
  regular_work_data: "The app is handling regular work data. This might take some time.",
  issue_data: "The app is handling issue data. This might take some time.",
  item_data: "The app is handling item data. This might take some time.",
  item_attribute_data: "The app is handling item attribute data. This might take some time.",
  model_data: "The app is handling model data. This might take some time.",
  unsubmitted_work_data: "The app is handling unsubmitted work data. This might take some time.",
  workspace_data: "The app is handling workspace data. This might take some time.",
  uploading_file: "File is being uploaded. This might take some time.",
  raised_issues: "Getting raised issues.",
  work_order_corrective:
    "The app is handling work order corrective data. This might take some time.",
  work_order_regular: "The app is handling work order regular data. This might take some time.",
}
